import http from "@/http.js";
import base from "@/api/base.js";

const vendor = {
    //根據員工id產生員工詳細資料---get
    vendorEmployeeGet(params) {
        return http.get(`${base.api}employee/${params}`);
    },
    //根據員工id修改員工詳細資料---get
    vendorEmployeePut(params, data) {
        return http.post(`${base.api}employee/${params}`, data, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    },
    //根據承攬商id新增員工資料---post
    vendorEmployeePost(params, data) {
        return http.post(`${base.api}vendor/${params}/employee`, data, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    },
    //根據承攬商id取得承攬商公司資料--get
    vendorBasisGet(params) {
        return http.get(`${base.api}vendor/${params}`);
    },
    //根據承攬商id修改承攬商公司資料--post
    vendorBasisPost(params, data) {
        return http.post(`${base.api}vendor/${params}`, data);
    },
    //根據承攬商id修改承攬商公司資料--post
    vendorNewPaper(params, data) {
        return http.post(`${base.api}vendor/${params}/new_safe_file`, data);
    },
    //根據承攬商id 存擋 承攬商公司資料--post
    vendorBasisSave(params, data) {
        return http.post(`${base.api}vendor_temp/${params}`, data);
    },
    //根據員工id顯示他會上什麼課程
    employeeCourse(params1) {
        return http.get(`${base.api}employee_course/${params1}`);
    },
    //根據課程id考試
    cousreTest(params) {
        return http.get(`${base.api}random_question/${params}`);
    },
    //根據employee_id跟course_id上傳考試分數
    //post的data放score 跟 question[]
    score(params1, params2, data) {
        return http.post(`${base.api}score/${params1}/${params2}`, data);
    },
    //根據employee_id跟course_id印出考卷
    print(params1, params2) {
        return http.get(`${base.api}print_paper/${params1}/${params2}`);
    },
    //根據employee_id跟course_id上傳考卷
    scoreUploade(params1, params2, data) {
        return http.post(`${base.api}paper/${params1}/${params2}`, data, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    },
    //每日施工單
    getDailyConstruction(search, id, params) {
        if (search) {
            return http.get(`${base.api}work`, {
                params: search,
            });
        } else if (id) {
            return http.get(`${base.api}work/${id}`);
        } else {
            return http.get(`${base.api}work`, {
                params: params,
            });
        }
    },
    postDailyConstruction(data, params) {
        if (params) {
            return http.put(`${base.api}work/${params}`, data);
        } else {
            return http.post(`${base.api}work`, data);
        }
    },
    newpostDailyConstruction(data, params) {
        if (params) {
            return http.put(`${base.api}new_work/${params}`, data);
        } else {
            return http.post(`${base.api}new_work`, data);
        }
    },
    delDailyConstruction(params) {
        return http.delete(`${base.api}work/${params}`);
    },
    //Get 新施工單資料
    getNewConstruction(search, id) {
        if (search) {
            return http.get(`${base.api}new_work`, {
                params: search,
            });
        } else if (id) {
            return http.get(`${base.api}new_work/${id}`);
        } else {
            // return http.get(`${base.api}new_work`,{
            //   params:params
            // });
            return http.get(`${base.api}new_work`);
        }
    },
    //for guide頁面使用
    getNewDailyConstruction(search) {
        if (search) {
            return http.get(`${base.api}today_new_work`, {
                params: search,
            });
        } else {
            return http.get(`${base.api}today_new_work`);
        }
    },
};
const admin = {
    //承攬商列表--get
    //用承攬商的中文名字搜尋承攬商
    vendorList(params) {
        if (params) {
            return http.get(`${base.api}vendorlist/${params}`);
        } else {
            return http.get(`${base.api}vendorlist`);
        }
    },
    //根據承攬商id看員工列表--get
    venderEmployee(params) {
        return http.get(`${base.api}vendor/${params}/employeelist`);
    },
    //根據員工id產生合格證
    makeCode(params) {
        return http.get(`${base.api}makecode/${params}`);
    },
    //根據承攬商id審核通過承攬商
    vendorCheck(params) {
        return http.put(`${base.api}vendor_pass/${params}`);
    },
    //根據承攬商id審核不通過承攬商，以及原因
    vendorCancel(params, data) {
        return http.put(`${base.api}vendor_cancel/${params}`, data);
    },
    //教材資料總表
    //或依據課程id找該課程
    course(params) {
        if (params) {
            return http.get(`${base.api}course/${params}`);
        } else {
            return http.get(`${base.api}course`);
        }
    },
    //新增修改教材
    coursePost(data, params) {
        if (params) {
            //修改
            return http.post(`${base.api}course/${params}`, data, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
        } else {
            //新增
            return http.post(`${base.api}course`, data, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
        }
    },
    //根據course_id刪除教材
    courseDel(params) {
        return http.delete(`${base.api}course/${params}`);
    },
    //根據question_id刪除題目
    questionDel(params) {
        return http.delete(`${base.api}question/${params}`);
    },

    //新增公告
    announcement(data) {
        return http.post(`${base.api}announcement`, data, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    },
    //公告修改
    announcementPut(params, data) {
        return http.post(`${base.api}announcement/${params}`, data, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    },

    //公告get
    announcementGet(params) {
        if (params) {
            return http.get(`${base.api}announcement/${params}`);
        } else {
            return http.get(`${base.api}announcement`);
        }
    },

    //公告刪除
    announcementDel(params) {
        return http.delete(`${base.api}announcement/${params}`);
    },
    //公告裡的檔案刪除，根據attachment_id
    attachmentDel(params) {
        return http.delete(`${base.api}attachment/${params}`);
    },
    // 特殊作業列表
    specialOperation() {
        return http.get(`${base.api}operation`);
    },
    //新增/修改施工單
    addConstruction(data, params) {
        if (params) {
            return http.put(`${base.api}construction/${params}`, data);
        } else {
            return http.post(`${base.api}construction`, data);
        }
    },
    //刪除施工單
    delConstruction(params) {
        return http.delete(`${base.api}construction/${params}`);
    },
    // 取得施工單列表,還有加上日期搜尋
    getConstruction(params, obj) {
        if (params) {
            return http.get(`${base.api}construction/${params}`);
        } else {
            return http.get(`${base.api}construction`, obj);
        }
    },
    //用員工ID領證
    getReceive(params) {
        return http.put(`${base.api}receive/${params}`);
    },
    //用員工ID取消領證
    cancelReceive(params) {
        return http.put(`${base.api}cancel/${params}`);
    },
    //需求單位列表
    department() {
        return http.get(`${base.api}department`);
    },
    employee() {
        return http.get(`${base.api}uof/user`);
    },
    // 取得email
    email(params) {
        if (params) {
            console.log(params);
            return http.get(`${base.api}mail/${params}`);
        } else {
            return http.get(`${base.api}mail`);
        }
    },
    //需求單位人員列表
    departmentEmployee(params) {
        if (params) {
            return http.get(`${base.api}mail/department/${params}`);
        } else {
            return console.log("沒有帶入部門params");
        }
    },
    postDepartmentEmployee(department_id, mail_id, data) {
        //params 代表部門
        if (mail_id) {
            return http.put(
                `${base.api}mail/department/${department_id}/${mail_id}`,
                data
            );
        } else {
            return http.post(
                `${base.api}mail/department/${department_id}`,
                data
            );
        }
    },
    // 存入email
    postEmail(data, params) {
        if (params) {
            return http.put(`${base.api}mail/${params}`, data);
        } else {
            return http.post(`${base.api}mail`, data);
        }
    },

    bossEmail(params) {
        if (params) {
            return http.get(`${base.api}boss/${params}`);
        } else {
            return http.get(`${base.api}boss`);
        }
    },
    // 存入email
    postBossEmail(data, params) {
        if (params) {
            return http.put(`${base.api}boss/${params}`, data);
        } else {
            return http.post(`${base.api}boss`, data);
        }
    },

    location(params) {
        if (params) {
            return http.get(`${base.api}area/${params}`);
        } else {
            return http.get(`${base.api}area`);
        }
    },
    postLocation(data, params) {
        if (params) {
            return http.put(`${base.api}area/${params}`, data);
        } else {
            return http.post(`${base.api}area`, data);
        }
    },
    delLocation(params) {
        return http.delete(`${base.api}area/${params}`);
    },

    delEmail(params) {
        return http.delete(`${base.api}mail/${params}`);
    },
    delBossEmail(params) {
        return http.delete(`${base.api}boss/${params}`);
    },

    departmentManagePost(data) {
        return http.post(`${base.api}vendor_dp`, data);
    },
    departmentManageDel(data) {
        return http.delete(`${base.api}vendor_dp`, data);
    },
    clearPaper(data) {
        return http.post(`${base.api}clear_paper`, data);
    },
    //開立工程單
    getApplication(search) {
        if (search) {
            return http.get(`${base.api}application`, {
                params: search,
            });
        } else {
            return http.get(`${base.api}application`);
        }
    },
    postApplication(data, params) {
        if (params) {
            return http.put(`${base.api}application/${params}`, data);
        } else {
            return http.post(`${base.api}application`, data);
        }
    },
    delApplication(params) {
        return http.delete(`${base.api}application/${params}`);
    },
    updateApplication() {
        return http.get(`${base.api}update/application`);
    },
    updateWork() {
        return http.get(`${base.api}update/work`);
    },
    updateNewWork() {
        return http.get(`${base.api}update/new_work`);
    },
    updateUrgent() {
        return http.get(`${base.api}update/urgent`);
    },
    //開立緊急單
    postUrgent(data) {
        return http.post(`${base.api}urgent`, data);
    },
    getUrgent(search, id) {
        if (id) {
            return http.get(`${base.api}urgent/${id}`, search);
        } else {
            return http.get(`${base.api}urgent`, search);
        }
    },
    postSafety(data) {
        return http.post(`${base.api}safety`, data);
    },
    getSafety(search) {
        return http.get(`${base.api}safety`, search);
    },
    deleteSafety(id) {
        return http.delete(`${base.api}safety/${id}`);
    },
    safetyUpload(id, data) {
        return http.post(`${base.api}safety/${id}/upload`, data);
    },
    //紙本施工單
    postPaperWork(data) {
        return http.post(`${base.api}paper_work`, data);
    },
    getPaperWork(search) {
        return http.get(`${base.api}paper_work`, search);
    },
    deletePaperWork(id) {
        return http.delete(`${base.api}paper_work/${id}`);
    },
    PaperWorkUpload(id, data) {
        return http.post(`${base.api}paper_work/${id}/upload`, data);
    },
    //紙本警衛清潔單
    postCleanContract(data) {
        return http.post(`${base.api}clean_contract`, data);
    },
    getCleanContract(search) {
        return http.get(`${base.api}clean_contract`, search);
    },
    deleteCleanContract(id) {
        return http.delete(`${base.api}clean_contract/${id}`);
    },
    PaperCleanContractUpload(id, data) {
        return http.post(`${base.api}clean_contract/${id}/upload`, data);
    },
    //刪除員工
    deleteEmployee({ id }) {
        return http.delete(`${base.api}employee/${id}`);
    },
    //開立事業單位
    postBusineseWork(data) {
        return http.post(`${base.api}business_work`, data);
    },
    getBusineseWork(search, id, params) {
        if (search) {
            return http.get(`${base.api}business_work`, {
                params: search,
            });
        } else if (id) {
            return http.get(`${base.api}business_work/${id}`);
        } else {
            return http.get(`${base.api}business_work`, {
                params: params,
            });
        }
    },
    updateBusineseWork() {
        return http.get(`${base.api}update/business_work`);
    },
};
const paper = {
    commit(data) {
        return http.post(`${base.api}commit`, data);
    },
    toolbox(data) {
        return http.post(`${base.api}toolbox`, data);
    },
    getCommit(params) {
        return http.get(`${base.api}new_commit/${params}`);
    },
    putCommit(params, data) {
        return http.put(`${base.api}new_commit/${params}`, data);
    },
    getToolbox(params) {
        return http.get(`${base.api}new_toolbox/${params}`);
    },
    putToolbox(params, data) {
        return http.put(`${base.api}new_toolbox/${params}`, data);
    },
};


const login = {
    //承攬商
    vendorLogin(data) {
        return http.post(`${base.api}vendor_login`, data);
    },
    //承攬商註冊
    vendorRegister(data) {
        return http.post(`${base.api}vendor_register`, data);
    },
    //工安
    managerLogin(data) {
        return http.post(`${base.api}manager_login`, data);
    },
    //修改密碼
    password(params, data) {
        return http.put(`${base.api}vendor_password/${params}`, data);
    },
    passwordDeprartment(params, data) {
        return http.put(`${base.api}manager_password/${params}`, data);
    },
};
const file = {
    //註冊需下載的文件api
    registerDow() {
        return http.get(`${base.api}filelist`);
    },
    //上傳文件
    registerUpload(data, params) {
        if (params) {
            return http.post(`${base.api}filelist/${params}`, data, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
        } else {
            return http.post(`${base.api}filelist`, data, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
        }
    },
    //上傳施工單文件
    //get施工單文件
    getOrder() {
        return http.get(`${base.api}orderlist`);
    },
    postOrder(data, params) {
        if (params) {
            return http.post(`${base.api}orderlist/${params}`, data, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
        } else {
            return http.post(`${base.api}orderlist`, data, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
        }
    },

    //註冊需下載的文件api
    guideDow() {
        return http.get(`${base.api}guide`);
    },

    //上傳使用手冊文件
    guideUpload(data, params) {
        return http.post(`${base.api}guide/${params}`, data, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    },
    deleteFile(id, file_id) {
        return http.delete(`${base.api}delete_file/${id}/${file_id}`);
    },
    workUpload(id, data) {
        return http.post(`${base.api}workUpload/${id}`, data, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    },
    //NEW施工單的備註文件
    new_workUpload(id, data) {
        return http.post(`${base.api}new_workUpload/${id}`, data, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    },
    //NEW施工單的每日結案文件(type = 每日巡檢表 or 危險作業檢查表)
    dailysWorkUpload(id, type, data) {
        return http.post(
            `${base.api}new_work_daily/${id}/upload/${type}`,
            data,
            {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            }
        );
    },
    //特殊作業取消
    dailyDangerCancel(id, cancel_op) {
        return http.put(`${base.api}new_work_daily/${id}`, {
            cancel_op: cancel_op,
        });
    },
    urgentUpload(id, data) {
        return http.post(`${base.api}urgentUpload/${id}`, data, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    },
    deleteUrgentFile(id, file_id) {
        return http.delete(`${base.api}delete_urgent_file/${id}/${file_id}`);
    },
    //原事業單位施工單的上傳備註文件
    busineseUpload(id, data) {
        return http.post(`${base.api}business_workUpload/${id}`, data, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
    },
    deleteBusineseFile(id, file_id) {
        return http.delete(
            `${base.api}delete_business_work_file/${id}/${file_id}`
        );
    },
};

export default {
    vendor,
    admin,
    paper,
    login,
    file,
};
